import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const cyberflexNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.cyberflex_requests, {
      displayName: 'Requests',
      icon: SolIcon.document,
      showChildrenAsTabs: true,
      children: [
        SolNavbarItem.of(PrototypeRouteId.cyberflex_requests_overview, {
          displayName: 'Overview',
        }),
        SolNavbarItem.of(PrototypeRouteId.cyberflex_requests_engagement, {
          displayName: 'Engagement requests',
          children: [
            SolNavbarItem.of(PrototypeRouteId.cyberflex_requests_detail, {
              displayName: 'asm-prototype.cyberflex.requests.detail.name',
              nameParams: ['requestName'],
              showChildrenInNavbar: false,
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(PrototypeRouteId.cyberflex_requests_detail_overview, {
                  displayName: 'Overview',
                }),
                SolNavbarItem.of(PrototypeRouteId.cyberflex_requests_detail_comments, {
                  displayName: 'Comments',
                }),
                SolNavbarItem.of(PrototypeRouteId.cyberflex_requests_detail_activity, {
                  displayName: 'Activity',
                }),
              ],
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.cyberflex_assets, {
      displayName: 'Assets',
      icon: SolIcon.asm_assets,
      children: [
        SolNavbarItem.of(PrototypeRouteId.cyberflex_assets_domains, {
          displayName: 'Domains',
          icon: SolIcon.asm_domains,
        }),
        SolNavbarItem.of(PrototypeRouteId.cyberflex_assets_hosts, {
          displayName: 'Hosts',
          icon: SolIcon.asm_hosts,
        }),
        SolNavbarItem.of(PrototypeRouteId.cyberflex_assets_websites, {
          displayName: 'Websites',
          icon: SolIcon.asm_websites,
        }),
      ],
    }),
  ],
  system: [
    SolNavbarItem.of(PrototypeRouteId.cyberflex_requests, {
      displayName: 'Requests',
      icon: SolIcon.document,
      showBadge: true,
    }),
  ],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
